// Dropdown.tsx

import { useRef, useState } from 'react';
import styles from './Dropdown.module.css';
import arrow_up from '../Images/arrow_up.svg';
import arrow_down from '../Images/arrow_down.svg';
import useOnClickOutside from '../hooks/useOnClickOutside.ts';

interface DropdownProps {
  title: string;
  setSelectState: (state: string) => void;
  data?: string[];
  maxLength?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  title,
  setSelectState,
  data,
  maxLength = false,
}) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const [selected, setIsSelected] = useState<string>(title);

  const popUpMenuRef = useRef<HTMLDivElement>(null);

  const handleOnClickLabel = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const target = e.target as HTMLElement;
    const textContent = target.textContent;
    if (textContent) {
      setIsSelected(textContent);
      setSelectState(textContent);
    }
    setIsActive(false);
  };

  const clickOutSideHandler = () => {
    setIsActive(false);
  };
  useOnClickOutside(popUpMenuRef, clickOutSideHandler);

  const dropdownBtnTitles = [
    'Select role',
    'State',
    'County',
    'Formation',
    'Service',
    'Operator',
    'TVD',
    'Pad',
    'Well',
    'Customer',
  ];

  return (
    <div
      className={styles.dropdown}
      ref={popUpMenuRef}
      style={{ maxWidth: maxLength ? 'auto' : '300px' }}
    >
      <div
        onClick={() => setIsActive((prev) => !prev)}
        className={
          dropdownBtnTitles.includes(selected)
            ? styles.dropdown_btn
            : styles.dropdown_btn2
        }
      >
        <span>{selected}</span>
        <img
          src={isActive ? arrow_up : arrow_down}
          alt={isActive ? 'Close Dropdown' : 'Open Dropdown'}
          className={styles.user_img}
        />
      </div>
      {isActive && (
        <div className={styles.dropdown_content}>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <div
                key={index}
                onClick={handleOnClickLabel}
                className={styles.item}
              >
                {item}
              </div>
            ))
          ) : (
            <>
              <div
                onClick={handleOnClickLabel}
                className={styles.item}
              >
                Viewer
              </div>
              <div
                onClick={handleOnClickLabel}
                className={styles.item}
              >
                Editor
              </div>
              <div
                onClick={handleOnClickLabel}
                className={styles.item}
              >
                Manager
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
